import React from 'react';

import { QAlert, QText, QBox, useCurrentUser, QTooltip, QApprovalRequestAlert } from '@qualio/ui-components';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { ChangeControl, ChangeControlReviewStatus, SupplierStatus } from 'types';
import { formatLocalizedDateTime } from 'utils';

type ChangeControlAlertProps = {
  changeControl?: ChangeControl;
  supplierStatus: SupplierStatus;
  handleStatusChangeModal: any;
};
const ChangeControlAlerts: React.FC<ChangeControlAlertProps> = ({
  changeControl,
  supplierStatus,
  handleStatusChangeModal,
}) => {
  const { t } = useTranslation();
  const { userId } = useCurrentUser();
  const showConfirmationAlert = (): boolean => {
    return !!changeControl?.reviews?.some(
      (review) => review.reviewer.id === userId && review.status === ChangeControlReviewStatus.enum.PENDING,
    );
  };

  const getRejectionDescription = (review: any) => {
    return (
      <QBox display="flex" flexDirection="row" alignItems={'center'} justifyContent={'left'}>
        <QText weight="semibold" pr={3}>
          {supplierStatus === 'DRAFT'
            ? t('changeControlAlerts.approvalPreviouslyDeclined')
            : t('changeControlAlerts.approvalDeclined')}
        </QText>{' '}
        <QBox>
          <QTooltip label={review.reviewer.email}>
            <QText as="u">
              {review.reviewer.fullName} {'  '}
            </QText>
          </QTooltip>
          {t('changeControlAlerts.declinedMessage', {
            name: review.reviewer.fullName,
            date: formatLocalizedDateTime(DateTime.fromISO(review.reviewedAt as string)),
            reason: review.comment || '--',
          })}
        </QBox>
      </QBox>
    );
  };
  const showRejectionReason = () => {
    return (
      <>
        {changeControl?.reviews
          ?.filter((review) => review.status === 'REJECTED')
          .map((review, index) => (
            <QAlert
              status={supplierStatus === 'DRAFT' ? 'info' : 'error'}
              key={index}
              description={getRejectionDescription(review)}
            />
          ))}
      </>
    );
  };

  return showConfirmationAlert() && supplierStatus === 'REVIEW_PENDING' ? (
    <QApprovalRequestAlert
      onApprove={() => handleStatusChangeModal('APPROVED')}
      onReject={() => handleStatusChangeModal('REJECTED')}
    />
  ) : (
    showRejectionReason()
  );
};

export default ChangeControlAlerts;
